import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  string,
  shape,
  number,
  oneOf,
  oneOfType,
  func,
} from 'prop-types';
import {
  FlexContainer,
  Typography,
  Icon,
  COLORS,
} from '@hyphengroup/cag-components';

import { nativeTemplate } from './helpers/Utils';

const INTERVAL_PERIOD = 1000;

const CountDown = (props) => {
  const {
    fromTime,
    toTime,
    displayFormat,
    loadingText,
    timeOffset,
    name,
    endText,
    maxUnit,
    iconName,
    iconSize,
    fontColor,
    fontSize,
    onEnded,
    ...rest
  } = props;
  const [display, setDisplay] = useState(loadingText);

  const setCurrentDisplay = () => {
    const currentTime = fromTime
      ? moment(fromTime).utcOffset(timeOffset).unix()
      : moment().utcOffset(timeOffset).unix();
    const eventTime = moment(toTime).utcOffset(timeOffset).unix();
    const diffTime = eventTime - currentTime;
    if (diffTime < 0) return true;
    const duration = moment.duration(diffTime * INTERVAL_PERIOD, 'milliseconds');
    const countObject = {
      year: duration.years(),
      month: maxUnit === 'month' ? Math.floor(duration.asMonths()) : duration.months(),
      day: maxUnit === 'day' ? Math.floor(duration.asDays()) : duration.days(),
      hour: maxUnit === 'hour' ? Math.floor(duration.asHours()) : duration.hours(),
      minute: maxUnit === 'minute' ? Math.floor(duration.asMinutes()) : duration.minutes(),
      sec: maxUnit === 'sec' ? Math.floor(duration.asSeconds()) : duration.seconds(),
    };
    const formatTemplate = nativeTemplate(displayFormat, countObject);
    setDisplay(formatTemplate);
    return diffTime <= 0;
  };

  useEffect(() => {
    setCurrentDisplay();
    const tempInterval = setInterval(() => {
      const isEnded = setCurrentDisplay();
      if (isEnded) {
        setDisplay(endText);
        onEnded?.();
        clearInterval(tempInterval);
      }
    }, INTERVAL_PERIOD);
    return () => {
      clearInterval(tempInterval);
    };
  }, []);

  return (
    <FlexContainer justifyContent="center" alignItems="center" {...rest}>
      <Icon iconName={iconName} size={iconSize} color={fontColor} />
      <Typography color={fontColor} sizeFont={fontSize} {...rest}>
        {name}
        &nbsp;&nbsp;
        {display}
      </Typography>
    </FlexContainer>
  );
};

CountDown.defaultProps = {
  fromTime: null,
  timeOffset: 0,
  loadingText: '',
  endText: '',
  maxUnit: 'year',
  iconName: 'welcome',
  iconSize: 'small',
  fontColor: COLORS.BRAND_01,
  fontSize: 'px12',
};

CountDown.propTypes = {
  fromTime: oneOfType([string, shape({})]),
  toTime: oneOfType([string, shape({})]).isRequired,
  timeOffset: number,
  name: string.isRequired,
  loadingText: string,
  endText: string,
  displayFormat: string.isRequired,
  maxUnit: oneOf(['year', 'month', 'day', 'hour', 'minute', 'sec']),
  iconName: string,
  iconSize: string,
  fontColor: string,
  fontSize: string,
  onEnded: func,
};

export default CountDown;
